import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import UIApplication from 'UIComponents/app/UIApplication';
import UIBox from 'UIComponents/layout/UIBox';
import MarketingNav, { MARKETING_NAV_LANGUAGES, getMarketingNavLanguagesContent } from 'marketplace-ui-common/components/MarketingNav';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import useShortlinkParams from '../utils/hooks/useShortlinkParams';
import { getAppShortlink, getSignupUrl, getContactUrl, getLocalizedPublicPath, getLocalizedPublicUrl
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
} from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIApplication = styled(UIApplication).withConfig({
  displayName: "PublicApplication__StyledUIApplication",
  componentId: "ksfopt-0"
})(["display:flex;flex-direction:column;"]);
const StyledMainContent = styled(props => /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
  grow: 1,
  shrink: 1
}))).withConfig({
  displayName: "PublicApplication__StyledMainContent",
  componentId: "ksfopt-1"
})(["min-height:100vh;"]);
export default function PublicApplication(_ref) {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    pathname
  } = useLocation();
  const shortlinkParams = useShortlinkParams();
  const lang = getLang();
  const languagesContent = useMemo(() => {
    return getMarketingNavLanguagesContent(Object.keys(MARKETING_NAV_LANGUAGES).reduce((final, languageCode) => {
      final[languageCode] = getLocalizedPublicPath(languageCode, pathname.replace(/\/$/, ''));
      return final;
    }, {}));
  }, [pathname]);
  const headerContentBlob = useMemo(() => {
    const contactText = unescapedText('appMarketplace.publicApplication.header.contactText');
    const contactUrl = getContactUrl(lang);
    const ctaText = unescapedText('appMarketplace.publicApplication.header.ctaText');
    const ctaUrl = getSignupUrl(lang, pathname);
    return {
      upperNavContent: {
        homeUrl: getLocalizedPublicUrl(lang, ''),
        loginUrl: getAppShortlink(pathname, shortlinkParams),
        loginText: unescapedText('appMarketplace.publicApplication.header.loginText'),
        ctaUrl,
        ctaText,
        regionalDropdownContent: {
          contactUrl,
          contactText,
          languagesContent
        }
      },
      mobileNavContent: {
        contactUrl,
        contactText,
        ctaUrl,
        ctaText,
        languagesContent,
        searchPlaceholder: unescapedText('appMarketplace.publicApplication.header.searchPlaceholder')
      }
    };
  }, [lang, languagesContent, pathname, shortlinkParams]);
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    _jsx(StyledUIApplication, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(MarketingNav, {
        enableConvertFlag: true,
        headerContentBlob: headerContentBlob,
        children: /*#__PURE__*/_jsx(StyledMainContent, {
          children: children
        })
      })
    }))
  );
}